module.exports = __webpack_public_path__ + "static/img/after_three.5252d86.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/after_three.png
// module id = N4ip
// module chunks = 1